import React from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
} from "react-simple-maps";

import allStates from "./allstates.json";
import styles from "./MapGraphic.module.css"

const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const MapChart = ({ statesData, setTooltipContent, setTooltipCountry }) => {
  return (
    <div data-tip="" className={styles.map}>
      <ComposableMap projection="geoAlbersUsa">
        <Geographies geography={geoUrl}>
          {({ geographies }) => (
            <>
              {geographies.map((geo) => {
                let fill = "#daf6ff";
                let count = 0;
                const cur = allStates.find((s) => s.val === geo.id);
                if (!!statesData[cur.id]) {
                  fill = statesData[cur.id].fill
                    ? statesData[cur.id].fill
                    : "#daf6ff";
                  count = statesData[cur.id].perMillion.toFixed(2);
                }
                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill={fill}
                    onMouseEnter={() => {
                      setTooltipContent(count.toString());
                      setTooltipCountry(`${geo.properties.name}`);
                    }}
                    onMouseLeave={() => {
                      setTooltipContent("");
                      setTooltipCountry("");
                    }}
                    style={{
                      hover: {
                        stroke: "#000000",
                        strokeWidth: 1,
                        outline: "none",
                      },
                    }}
                    className="z-n"
                  />
                );
              })}
            </>
          )}
        </Geographies>
      </ComposableMap>
    </div>
  );
};

export default MapChart;
